import API from 'api/API'
import React, { useEffect, useState } from 'react'
import { CardData } from 'api/Models'
import CardCard from 'components/elements/CardCard'
import BasePage from 'components/pages/BasePage'
import { RiseLoader } from 'react-spinners'
import PageHeader from '../elements/PageHeader'
import { Col } from 'react-bootstrap'
import { newCardRoute } from '../../Routes'
import LinkButton from '../elements/LinkButton'
import creditCardPlus from '../../assets/imgs/icons/credit-card-plus.svg'

export interface CardManagementPageProps {}

function HeaderControls() {
	return (
		<>
			<Col className="me-auto"></Col>
			<Col>
				<div className="page-nav">
					<LinkButton to={newCardRoute} icon={creditCardPlus} label="New Card" type="primary" />
				</div>
			</Col>
		</>
	)
}

function CardManagementPage(props: CardManagementPageProps) {
	const [isLoading, setIsLoading] = useState(false)
	const [cards, setCards] = useState<CardData[]>([])
	const [page, setPage] = useState(0)
	const [hasMore, setHasMore] = useState(true)
	const pageSize = 5

	const addCards = (newCards: CardData[]) => {
		if (newCards.length === 0) setCards([...cards, ...newCards])
	}

	const fetchData = (page: number) => {
		setIsLoading(true);

		API.Cards.GetCards({
			withBalance: true,
			'OffsetPaging.Skip': page * pageSize,
			'OffsetPaging.Take': pageSize,
		}).then((r) => {
			addCards(r.data!.data)
			setHasMore(r.data!.data.length >= pageSize)
			setCards(c => [...c, ...r.data!.data])
		}).finally(() => setIsLoading(false))
	}

	const handleScroll = () => {
		if(!hasMore ) {
			return;
		}

		if (
			window.innerHeight + document.documentElement.scrollTop !== document.documentElement.offsetHeight ||
			isLoading
		) {
			return
		}
		setPage(page + 1)
	}

	useEffect(() => {
		window.addEventListener('scroll', handleScroll)
		return () => window.removeEventListener('scroll', handleScroll)
	}, [isLoading])

	useEffect(() => {
		fetchData(page)
	}, [page])

	// const onscroll = () => {}

	const headerControl = <HeaderControls />
	return cards === null ? (
		<>
			<PageHeader title={'Card Management'} controls={headerControl} />
			<BasePage className="cd-management">
				<RiseLoader size={20} />
			</BasePage>
		</>
	) : (
		<>
			<PageHeader title={'Card Management'} controls={headerControl} />
			<BasePage className="cd-management">
				{cards.map((c, index, cards) => {
					const asd = {
						id: c.id ?? '',
						cardId: c.cardId ?? '',
						design: c.cardDesign ?? 0,
						type: c.type ?? 'Unknown',
						number: c.processorData?.obscuredPan ?? '',
						customName: c.alias ?? c.processorData?.embossName ?? '',
						balance: c.balance ?? 0,
						currency: c.currency ?? 'USD',
						status: c.status ?? 'Unknown',
						limit: c.creditLimit ?? 0,
						linkedUser: c.userId ?? 'Unknown',
						cardType: c.type ?? 'Unknown',
						expiryDate: c.processorData?.expiryDate ?? '',
					}

					return	<CardCard {...asd} />
				})}
				{isLoading && <RiseLoader size={20} />}
			</BasePage>
		</>
	)
}

export default CardManagementPage
